import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "past-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
export default /*@__PURE__*/_defineComponent({
  __name: 'past-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: "add"
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const isEdit = ref(true);
    const emit = __emit;
    const formRef = ref();
    const subBtnLoading = ref(false);
    const form = reactive({
      name: "",
      // 基本名称
      // diagnosisTime: 1710691200000, // 确诊时间
      diagnosisTime: null,
      // 确诊时间
      hospital: "",
      // 确诊医院
      treatmentResult: "",
      // 治疗结果
      remarks: "" // 备注
    });
    const rules = {
      name: [{
        required: true,
        message: "请输入用户名",
        trigger: "blur"
      }]
      // diagnosisTime: [{ required: true, message: '请选择确诊时间', trigger: 'blur' }],
      // hospital: [{ required: true, message: '请输入确诊医院', trigger: 'blur' }],
    };
    // 开启编辑模式
    function handleEdit() {
      isEdit.value = true;
    }
    // 日期发生变化
    function handleChangeDate(val) {
      console.log("val", val);
      const timeStap = new Date(val).getTime();
      console.log("timeStap", timeStap);
      form.diagnosisTime = timeStap;
      console.log("diagnosisTime", form.diagnosisTime);
    }
    function restForm() {
      formRef.value?.resetFields();
      form.name = "";
      form.diagnosisTime = null;
      form.hospital = "";
      form.treatmentResult = "";
      form.remarks = "";
      isEdit.value = true;
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning("正在保存，请稍后~~");
      restForm();
      emit("closeDialog");
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      let data = JSON.parse(JSON.stringify(form));
      restForm();
      emit("restData", data);
    }
    const title = computed(() => {
      if (props.dialogType === "add") {
        return "添加";
      } else if (props.dialogType === "edit") {
        return "编辑";
      }
    });
    watch(() => props.dialogVisible, newV => {
      if (newV && props.dialogType === "edit") {
        isEdit.value = false;
        form.name = props.itemData.name;
        form.diagnosisTime = props.itemData.diagnosisTime;
        form.hospital = props.itemData.hospital;
        form.treatmentResult = props.itemData.treatmentResult;
        form.remarks = props.itemData.remarks;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, _createSlots({
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              placeholder: "请输入名称",
              disabled: !isEdit.value
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "确诊时间",
            prop: "diagnosisTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              disabled: !isEdit.value,
              style: {
                "width": "100%"
              },
              modelValue: form.diagnosisTime,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.diagnosisTime = $event),
              type: "date",
              onChange: handleChangeDate,
              placeholder: "请选择确诊时间"
            }, null, 8, ["disabled", "modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "确诊医院",
            prop: "hospital"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.hospital,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.hospital = $event),
              placeholder: "请输入确诊医院",
              disabled: !isEdit.value
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "治疗结果"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.treatmentResult,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.treatmentResult = $event),
              placeholder: "请输入治疗结果",
              disabled: !isEdit.value
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.remarks,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.remarks = $event),
              placeholder: "请输入备注",
              disabled: !isEdit.value
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 2
      }, [__props.dialogType === 'edit' ? {
        name: "header",
        fn: _withCtx(() => [_createElementVNode("div", {
          class: "edit",
          onClick: handleEdit
        }, "编辑")]),
        key: "0"
      } : undefined, __props.dialogType === 'add' || isEdit.value ? {
        name: "footer",
        fn: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[6] || (_cache[6] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("确定")])),
          _: 1
        }, 8, ["loading"])])]),
        key: "1"
      } : undefined]), 1032, ["model-value", "title"])]);
    };
  }
});